import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyAuditInfoAndFeesDto, UpsertAuditInfoAndFeesRequest } from '../../models/api/companyAuditInfoAndFeesDto';
import { YearlyResource } from '../../models/api/yearlyResource';

@Injectable({
  providedIn: 'root'
})
export class CompanyAuditInfoFeesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyAuditInfoAndFeesDto[]>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyAuditInfoAndFeesDto[]>>(
      `${this.apiUrl}/${companyId}/audit-info-and-fees`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertAuditInfoAndFeesRequest): Observable<CompanyAuditInfoAndFeesDto> {
    return this.http.put<CompanyAuditInfoAndFeesDto>(`${this.apiUrl}/${companyId}/audit-info-and-fees`, request);
  }

  delete(companyId: string, year?: number, indexNumber?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    if (indexNumber !== undefined) {
      params = params.set('indexNumber', indexNumber.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/audit-info-and-fees`, { params });
  }
}
